import React from 'react';

export const Tab = ({ label, onClick, activeTab }) => {
  const onClickTab = () => {
    if (onClick) {
      onClick(label);
    }
  };

  let className = 'tab-list-item';

  if (activeTab === label) {
    className += ' tab-list-active';
  }

  return (
    <li className={className} onClick={onClickTab} aria-hidden>
      {label}
    </li>
  );
};
